import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "meeting-rescheduled-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "slide-header requested" }, "Congrats!", -1 /* HOISTED */)
const _hoisted_3 = { class: "slide-content" }
const _hoisted_4 = { class: "rescheduled-info-container" }
const _hoisted_5 = { class: "date-and-time" }
const _hoisted_6 = { class: "meeting-with" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "meeting-with-text" }, "Meeting With", -1 /* HOISTED */)
const _hoisted_8 = { class: "meeting-with-name" }
const _hoisted_9 = { class: "hold-info" }
const _hoisted_10 = { class: "more-info" }
const _hoisted_11 = { class: "other-details-container" }
const _hoisted_12 = { class: "sender-location" }
const _hoisted_13 = { class: "sender-location__heading" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Location (Address provided after payment)")
const _hoisted_15 = {
  key: 0,
  class: "description"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Video Link: ")
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 1,
  class: "description"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Phone Number: ")
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 2,
  class: "description"
}
const _hoisted_22 = { class: "line" }
const _hoisted_23 = {
  key: 0,
  class: "line"
}
const _hoisted_24 = { class: "line" }
const _hoisted_25 = {
  key: 3,
  class: "description"
}
const _hoisted_26 = {
  key: 4,
  class: "description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString($setup.meetingDate) + " at " + _toDisplayString($setup.meetingTime), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString($props.user.name.fullName), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, "Your card will be charged " + _toDisplayString($props.request.price.currency) + _toDisplayString($props.request.price.amount) + ", but will be held in the Opt escrow amount until the meeting is completed.", 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", null, "Please review your calendar for details about the meeting or reach out to " + _toDisplayString($props.user.name.fullName) + " with any questions.", 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          ($props.request?.location?.type == 'video')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("a", {
                  href: $props.request.location.fields.link,
                  target: "_blank"
                }, _toDisplayString($props.request.location.fields.link), 9 /* TEXT, PROPS */, _hoisted_17)
              ]))
            : ($props.request?.location?.type == 'phone')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("a", {
                    href: 'tel:'+$props.request.location.fields.number,
                    target: "_blank"
                  }, _toDisplayString($props.request.location.fields.number), 9 /* TEXT, PROPS */, _hoisted_20)
                ]))
              : ($props.request?.location?.type == 'physical')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString($props.request.location.fields.street1), 1 /* TEXT */),
                    ($props.request.location.fields.street2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($props.request.location.fields.street2), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_24, _toDisplayString($props.request.location.fields.city) + ", " + _toDisplayString($props.request.location.fields.state) + " " + _toDisplayString($props.request.location.fields.postal), 1 /* TEXT */)
                  ]))
                : ($props.request?.location?.type == 'other')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($props.request.location.fields.note), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, "No Location information provided"))
        ])
      ])
    ]),
    _createElementVNode("div", { class: "button-container center" }, [
      _createElementVNode("button", {
        class: "primary",
        onClick: $setup.proceed
      }, "Back to Home")
    ])
  ]))
}